import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

// Page 404. Volontairement noindex et sans canonical : Google ne doit ni l'indexer
// ni la rattacher à une URL existante (la plateforme ne permet pas de renvoyer un
// vrai code HTTP 404 — voir /app/memory/PRD.md, Iter 48).
const LINKS = [
  { to: "/cours", label: "Nos cours", testid: "notfound-link-cours" },
  { to: "/planning", label: "Planning", testid: "notfound-link-planning" },
  { to: "/stages", label: "Stages", testid: "notfound-link-stages" },
  { to: "/inscription", label: "Inscriptions", testid: "notfound-link-inscription" },
];

export default function NotFound() {
  useEffect(() => {
    document.title = "Cette page n'existe pas · 1000 ARTS";

    let robots = document.querySelector('meta[name="robots"]');
    const previousRobots = robots ? robots.getAttribute("content") : null;
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", "noindex, follow");

    const canonical = document.querySelector('link[rel="canonical"]');
    const previousCanonical = canonical ? canonical.getAttribute("href") : null;
    if (canonical) canonical.remove();

    return () => {
      if (previousRobots) robots.setAttribute("content", previousRobots);
      if (previousCanonical) {
        const link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        link.setAttribute("href", previousCanonical);
        document.head.appendChild(link);
      }
    };
  }, []);

  return (
    <div data-testid="notfound-page" className="pt-32 pb-24 relative overflow-hidden mesh-bg">
      <div className="max-w-[1000px] mx-auto px-6 md:px-12 relative z-10">
        <div className="eyebrow mb-3">Erreur 404</div>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight">
          Cette page n'existe pas
        </h1>
        <p className="text-base text-[var(--muted)] mt-5 leading-relaxed">
          Le lien que vous avez suivi est peut-être périmé, ou l'adresse comporte une erreur de frappe.
        </p>

        <div className="flex flex-wrap gap-3 mt-10">
          {LINKS.map((l, i) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              className={i === 0 ? "btn-primary" : "btn-outline"}
            >
              {l.label}
            </Link>
          ))}
          <Link to="/" data-testid="notfound-link-accueil" className="btn-ghost">
            Accueil
          </Link>
        </div>

        <p className="text-sm text-[var(--muted)] mt-10 flex items-center gap-2">
          <Mail size={15} style={{ color: "var(--primary)" }} />
          Une question&nbsp;? Écrivez-nous à{" "}
          <a
            href="mailto:info1000arts@gmail.com"
            data-testid="notfound-contact-email"
            style={{ color: "var(--primary)" }}
          >
            info1000arts@gmail.com
          </a>
        </p>
      </div>
    </div>
  );
}
